/**
 * alert Group
 * @param fb : FormBuilder
 */
export function sandboxGroup (fb: any):any {
    return fb.group({
        reference: fb.control(''),
        status: fb.control([]),
        includeMirrors: fb.control(''),
        distributor: fb.control([]),
        carrier: fb.control([]),
        end: fb.group({
            min: fb.control(''),
            max: fb.control('')
        }),
    });
}
